import { Chip, Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { DeviceConfiguration } from "../../../cobra-backend-client";

interface Props {
  updatedDeviceConfiguration: DeviceConfiguration;
  setUpdatedDeiceConfiguration: React.Dispatch<
    React.SetStateAction<DeviceConfiguration>
  >;
  platformSensorActive: boolean | undefined;
}

const PlatformSensorAutomaticTiltUp = (props: Props) => {
  const [platformSensorAutomaticTiltUp, setPlatformSensorAutomaticTiltUp] =
    useState(props.updatedDeviceConfiguration.automaticTilt?.up?.enable);

  useEffect(() => {
    setPlatformSensorAutomaticTiltUp(
      props.updatedDeviceConfiguration.automaticTilt?.up?.enable
    );
  }, [props.updatedDeviceConfiguration.automaticTilt?.up?.enable]);

  const onPlatformSensorBlinkModeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setPlatformSensorAutomaticTiltUp(checked);
    const newDeviceConfiguration: DeviceConfiguration = {
      ...props.updatedDeviceConfiguration,
      automaticTilt: {
        ...props.updatedDeviceConfiguration.automaticTilt,
        up: {
          ...props.updatedDeviceConfiguration.automaticTilt.up,
          enable: checked,
        },
      },
    };

    props.setUpdatedDeiceConfiguration(newDeviceConfiguration);
  };

  return (
    <>
      <Grid
        item
        xs={6}
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          display: "flex",
        }}
      >
        <Typography>Autotilt up </Typography>
        <Chip
          sx={{ ml: 1 }}
          variant="outlined"
          label={platformSensorAutomaticTiltUp ? "on" : "off"}
          color={platformSensorAutomaticTiltUp ? "success" : "error"}
          size="small"
        />
      </Grid>
      <Grid item xs={6} textAlign="right">
        <Switch
          checked={platformSensorAutomaticTiltUp}
          onChange={onPlatformSensorBlinkModeChange}
          inputProps={{ "aria-label": "controlled" }}
          disabled={!props.platformSensorActive}
        />
      </Grid>
    </>
  );
};

export { PlatformSensorAutomaticTiltUp };
